function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M54 24C54 37.2548 43.2548 48 30 48V0C43.2548 0 54 10.7452 54 24Z",
  fill: "url(#paint0_linear_feat2)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M12 24C12 30.6274 6.62742 36 0 36V12C6.62742 12 12 17.3726 12 24Z",
  fill: "url(#paint1_linear_feat2)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M30 24C30 33.9411 21.9411 42 12 42V6C21.9411 6 30 14.0589 30 24Z",
  fill: "url(#paint2_linear_feat2)"
});

var _ref5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_feat2",
  x1: 30,
  y1: 0,
  x2: 30,
  y2: 48,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#61FFF0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#EBFCAA"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_feat2",
  x1: 6,
  y1: 12,
  x2: 8.09905,
  y2: 35.815,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#BBF5EF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#6DEEE0"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear_feat2",
  x1: 12,
  y1: 6,
  x2: 12,
  y2: 42,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#61FFF0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#EBFCAA"
})));

var SvgFeature2 = function SvgFeature2(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 48,
    viewBox: "0 0 54 48",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFeature2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/feature-2.27223bfc.svg";
export { ForwardRef as ReactComponent };